import { ModalDescription } from '@lulalife/design-system';
import type { ReactNode } from 'react';

/**
 * The body of a Modal Confirmation (7529:22590, 8012:118250, 8200:29536; Service Requests
 * 7546:36787, 7546:37413): primary text, 4 under the title (`space/content/tight`).
 * DS-GAP(modal-confirmation-title-gap): DS `ModalHeader` stacks the title and the description with
 * no gap; remove the margin when the package adds it.
 */
export const ModalConfirmationDescription = ({ children }: { children: ReactNode }) => (
  <ModalDescription className="mt-space-content-tight text-text-primary">
    {children}
  </ModalDescription>
);
